function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { WDHImage } from '@demant/wdh';
import { TweenLite } from 'gsap/all';
import { triggerEvent } from '../../../../../../wdh-foundation/wdh';

function offset(el) {
  var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
}

var AsTabSpot = function AsTabSpot(_ref) {
  var settings = _ref.settings;
  var spotList = settings.elements || [];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentScrollTo = _useState4[0],
      setCurrentScrollTo = _useState4[1];

  var activeEl = useRef(null);
  var isDesktop = window.matchMedia('(min-width:768px)').matches;
  useEffect(function () {
    triggerEvent('link-embed-code-detected');
  });

  var scrollSelectedIntoView = function scrollSelectedIntoView() {
    var header = document.querySelector('.header-mobile-top.outer-container');

    if (header) {
      if (isActive !== null) {
        var selectedItem = activeEl.current;
        var offsetTop = offset(selectedItem).top - header.offsetHeight;
        var duration = offsetTop === currentScrollTo ? 0 : 0.6;
        setCurrentScrollTo(offsetTop);
        TweenLite.to(window, duration, {
          delay: 0,
          scrollTo: {
            y: offsetTop
          }
        });
      } else {
        TweenLite.to(window, 0, {
          delay: 0,
          scrollTo: {
            y: currentScrollTo
          }
        });
      }
    }
  };

  useEffect(function () {
    if (!isDesktop) {
      scrollSelectedIntoView();
    }
  }, [isActive]);

  var handleClick = function handleClick(index) {
    if (!isDesktop && isActive === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  var indexKey = 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "image-spot-elements"
  }, spotList.map(function (item, index) {
    if (item.header !== null) {
      return /*#__PURE__*/React.createElement("li", {
        className: "image-spot-element ".concat(isActive === index ? 'active' : ''),
        key: indexKey++,
        ref: isActive === index ? activeEl : null
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return handleClick(index);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "scLooseFrameZone",
        sc_item: item.sitecoreItem || ''
      }, /*#__PURE__*/React.createElement("span", {
        className: "scChromeData"
      }, item.sitecoreChromeData || ''), /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-inner-container"
      }, item.image && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-image"
      }, /*#__PURE__*/React.createElement(WDHImage, {
        image: item.image.image
      })), item.header && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-header",
        dangerouslySetInnerHTML: {
          __html: item.header
        }
      })))), !isDesktop && item.text && isActive === index && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-text",
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      }));
    }

    return null;
  })), spotList.map(function (item, index) {
    return isActive === index && isDesktop ? /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-text",
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }) : null;
  }));
};

export default AsTabSpot;